import { useRouter } from "next/router";

/** Parses query params for accountId */
export function useAccountIDParam(): string {
  const account_id = useRouter()?.query?.account_id ?? "";
  return Array.isArray(account_id) ? account_id[0] : account_id;
}
